export interface DueDate {
  enviar_email_em_dias?: number;
  repetir_email_em_dias?: number;
  limite_repeticao_email_em_dias?: number;
  status: boolean;
  tipo: NonPaymentTypes;
  id?: string;
}

// eslint-disable-next-line no-shadow
export enum NonPaymentTypes {
  ANTES_DO_VENCIMENTO = 1,
  DEPOIS_DO_VENCIMENTO = 2,
  PROTESTO = 3,
}

export interface Whitelist {
  nm_grupo: string;
  id: string;
}
